/**
 * Authenticated API client wrapper.
 * This module provides an axios instance that automatically attaches
 * authentication tokens to all requests.
 */

let getAuthToken = null;
let currentOrgId = null;

/**
 * Set the function used to get the current auth token.
 * This is called by App.jsx after Clerk is initialized.
 */
export function setAuthTokenGetter(getter) {
    getAuthToken = getter;
}

/**
 * Set the current organization ID.
 * This is used for multi-tenant API calls.
 */
export function setCurrentOrgId(orgId) {
    currentOrgId = orgId;
}

/**
 * Get the current organization ID.
 */
export function getCurrentOrgId() {
    return currentOrgId;
}

/**
 * Clear the current organization ID (e.g., on logout).
 */
export function clearCurrentOrgId() {
    currentOrgId = null;
}

/**
 * Get the current auth token if available.
 * Returns null if no token getter is set or if getting the token fails.
 */
export async function getToken() {
    if (!getAuthToken) {
        return null;
    }
    try {
        return await getAuthToken();
    } catch (error) {
        console.warn('[Auth] Failed to get token:', error);
        return null;
    }
}

/**
 * Create authorization headers for API requests.
 * Returns an object with Authorization and X-Org-ID headers if available.
 */
export async function getAuthHeaders() {
    const token = await getToken();
    const headers = {};
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    if (currentOrgId) {
        headers['X-Org-ID'] = currentOrgId;
    }
    return headers;
}
